import { createApplicationHooks } from '@/modules/service-desk/shared/application-hooks';
import {
  businessCardApi,
  changeBusinessCardStatus,
  submitBusinessCardApplication,
} from '../services/business-card.service';
import { BusinessCardApplication } from '../types/business-card.types';

const hooks = createApplicationHooks<BusinessCardApplication>({
  key: 'business-card',
  api: businessCardApi,
  withdrawWorkflow: 'BUSINESS_CARD_APPLICATION_WITHDRAW',
});

export const useBusinessCardApplications = hooks.useApplications;
export const useWithdrawBusinessCard = hooks.useWithdrawApplication;

export const useSubmitBusinessCard = () =>
  hooks.useApplicationMutation(submitBusinessCardApplication, 'REQUEST_SUBMITTED');

export const useChangeBusinessCardStatus = () =>
  hooks.useApplicationMutation(changeBusinessCardStatus, 'REQUEST_UPDATED');
